<app-form-schema-renderer
		*ngIf="resolvedSchema && data"
		[property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="!editFormular"
		[formID]="participantFormID" (emitFormSubmit)="submit($event)">
</app-form-schema-renderer>
<div *ngIf="!editFormular">
	<div nz-row [nzJustify]="'space-between'">
		<div nz-col>
			<div nz-row [nzGutter]="[16, 6]">
				<div nz-col>
					<app-splitbutton [elements]="[cancelParticipantButton]"></app-splitbutton>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="editFormular">
	<div nz-row [nzJustify]="'space-between'">
		<div nz-col>
			<div nz-row [nzGutter]="[16, 6]">
				<div nz-col>
					<app-splitbutton [elements]="[cancelParticipantButton]"></app-splitbutton>
				</div>
				<div nz-col>
					<app-splitbutton *ngIf="data"
									[elements]="[deleteParticipantButton]"></app-splitbutton>
				</div>
			</div>
		</div>
		<div nz-col>
			<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
				<div nz-col>
					<app-splitbutton *ngIf="resolvedSchema && data"
									[elements]="[editParticipantButton]"
					>
					</app-splitbutton>
				</div>
			</div>
		</div>
	</div>
</div>
